import React, { useState } from "react";
import { BURGUNDY, INK, INK_3, BG } from "../bureauTokens";

function RdvRow({ rdv, onClick }) {
  const [hover, setHover] = useState(false);
  const date = new Date(rdv.date);
  const dateLabel = isNaN(date)
    ? ""
    : date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit" });

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="w-full flex items-center gap-2.5 text-left rounded-lg transition-colors"
      style={{ padding: "8px", background: hover ? BG : "transparent" }}
    >
      <span className="text-[10.5px] font-bold whitespace-nowrap" style={{ color: BURGUNDY }}>
        {dateLabel} · {rdv.time}
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-[11px] font-semibold truncate" style={{ color: INK }}>
          {rdv.client}
        </span>
        <span className="block text-[10px] truncate" style={{ color: INK_3 }}>
          {rdv.motif}
        </span>
      </span>
      <span className="text-[10px] whitespace-nowrap" style={{ color: INK_3 }}>
        {rdv.canal}
      </span>
    </button>
  );
}

export default RdvRow;
